import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import $window from '../../tools/window';
import FranchisePortalModal from './FranchisePortalModal';
import useFranchiseCountryData from './hooks/useFranchiseCountryData';

const FranchisePortalFrontendWrapper = ({
  brand = 'anf',
  country,
}) => {
  // once we move the FranchisePortal Traffic to this endpoint,
  // we will want to move this hook down into the FranchisePortalModal
  const {
    countryCode,
    countryName,
    redirectUrl,
    showFranchisePortal,
    isMultiCountry,
    setViewedFranchisePortal,
  } = useFranchiseCountryData(country);

  useEffect(() => {
    const handleFranchiseCountryReset = () => {
      setViewedFranchisePortal(false);
    };

    $window.addEventListener('mfe:resetFranchiseCountry', handleFranchiseCountryReset);

    return () => {
      $window.removeEventListener('mfe:resetFranchiseCountry', handleFranchiseCountryReset);
    };
  }, [setViewedFranchisePortal]);

  if (!showFranchisePortal) {
    return null;
  }
  return (
    <FranchisePortalModal
      brand={brand}
      countryCode={countryCode}
      countryName={countryName}
      isMultiCountry={isMultiCountry}
      setViewedFranchisePortal={setViewedFranchisePortal}
      shipToLink={redirectUrl}
    />

  );
};

FranchisePortalFrontendWrapper.propTypes = {
  brand: PropTypes.string,
  country: PropTypes.string,
};

export default FranchisePortalFrontendWrapper;
